import { ReactElement } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import {
  ESportsbookPageTypes,
  TSportsbookConfigs
} from 'interfaces/sportsbook-configs';
import { MarketsListSkeleton } from 'components/MarketsList/Skeleton';
import { MatchHeader } from 'components/MatchHeader/Prematch';
import { MatchInfoCard } from 'components/MatchInfoCard';
import { TGameDataWithMoreInfo } from 'store/reducers/new-sportsbook';

type TProps = {
  configs: TSportsbookConfigs;
};

export const DesktopSingleGameViewSkeleton = ({
  configs
}: TProps): ReactElement => {
  const isLive = configs.pageType === ESportsbookPageTypes.live;
  const isESport = configs.pageType === ESportsbookPageTypes.esport;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: isESport ? 'calc(100% - 96px)' : '100%'
      }}
    >
      {SpringConfigs.MOCKED_DATA ? (
        <MarketsListSkeleton banner withMatchTracker={isLive} isLive={isLive} />
      ) : (
        <>
          {!isLive && !isMobile() && !isESport && (
            <MatchHeader gameData={{} as TGameDataWithMoreInfo} />
          )}
          {isLive && !isMobile() && !isESport && (
            <>
              {/* @ts-ignore */}
              <MatchInfoCard loading sportAlias="" game={{}} />
            </>
          )}
          <MarketsListSkeleton isLive={isLive} />
        </>
      )}
    </div>
  );
};
